export default __webpack_public_path__ + "static/media/finley.585af020.png";